import React from 'react';
import { Row, Col, Card } from 'reactstrap';
import { Link } from 'react-router-dom';

import { useSelector } from 'react-redux';
import Breadcrumbs from '../../components/Common/Breadcrumb';

import { useTranslation } from 'react-i18next';

const AdminDashboard = (props) => {
  const loading = useSelector((state) => state.Dashboard.loading);

  const { t } = useTranslation();

  return (
    <>
      <Breadcrumbs title={t('Dashboard')} loading={loading} />
      <Row>
        <Col md="4">
          <Card>
            <div className="text-center p-4 border-end">
              <div className="avatar-sm mx-auto mb-3 mt-1">
                <span className="avatar-title rounded-circle bg-soft bg-primary primary text-white font-size-16">
                  <i className="bx bx-credit-card font-size-20"></i>
                </span>
              </div>
              <h4 className="text-truncate pb-1">Abbonamenti</h4>
            </div>
            <div className="text-center text-xl-start mb-2">
              <Link
                to="/subscriptions/list"
                className="text-decoration-underline text-reset font-size-14">
                Vedi tutti gli abbonamenti{' '}
                <i className="mdi mdi-arrow-right font-size-14"></i>
              </Link>
            </div>
          </Card>
        </Col>
        <Col md="4">
          <Card>
            <div className="text-center p-4 border-end">
              <div className="avatar-sm mx-auto mb-3 mt-1">
                <span className="avatar-title rounded-circle bg-soft bg-secondary secondary text-white font-size-16">
                  <i className="bx bx-user-plus font-size-20"></i>
                </span>
              </div>
              <h4 className="text-truncate pb-1">Affiliati</h4>
            </div>
            <div className="text-center text-xl-start mb-2">
              <Link
                to="/affiliates/list"
                className="text-decoration-underline text-reset font-size-14">
                Vedi tutti gli affiliati{' '}
                <i className="mdi mdi-arrow-right font-size-14"></i>
              </Link>
            </div>
          </Card>
        </Col>
        <Col md="4">
          <Card>
            <div className="text-center p-4 border-end">
              <div className="avatar-sm mx-auto mb-3 mt-1">
                <span className="avatar-title rounded-circle bg-soft bg-success success text-white font-size-16">
                  <i className="bx bxs-coupon font-size-20"></i>
                </span>
              </div>
              <h4 className="text-truncate pb-1">Codici Sconto</h4>
            </div>
            <div className="text-center text-xl-start mb-2">
              <Link
                to="/discount-codes/list"
                className="text-decoration-underline text-reset font-size-14">
                Vedi tutti i codici sconto{' '}
                <i className="mdi mdi-arrow-right font-size-14"></i>
              </Link>
            </div>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default AdminDashboard;
